<template>
    <div>
        <el-radio-group v-model="radio" @change="handleCheckedQes" class="examRadio" :class="{'selected':isSelected || look }" :disabled='(isSelected || look)'>
        <!-- <el-radio-group v-model="radio" @change="handleCheckedQes" class="examRadio" :class="{'selected':isSelected }"> -->
            <el-radio :label="index" v-for='(item,index) in list.userOptions' :key='index'
                :class='[letter(index),answerRightError(index,list.answer)]'>{{item}}</el-radio>
        </el-radio-group>
        <div class="answerBox" v-show='isSelected || look'>
            <p>正确答案：{{ letter(list.answer-1) }}</p>
            <p>我的答案：{{ letter(selected[this.list.qid]-1) }}</p>
        </div>
    </div>

</template>
<script>
export default {
    props: {
        list: {
            type: Object
        },
        selected: {
            type: Object
        },
        look: {
            type: Boolean
        },
    },
    computed: {
        /**
         * 转化字母 添加class
         */
        letter () {
            return function (param) {
                return ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'][param];
            }
        },
        /**
         * 判断选项是正确还是错误  添加class
         */
        answerRightError () {
            return function (idx, answer) {
                idx = idx + 1;
                if (idx == answer) {
                    return 'ok';
                }else{
                    if (this.selected[this.list.qid] == idx) {
                        return 'error'
                    } 
                }
                return '';
            }
        },

    },
    watch: {
        selected () {
            if (this.selected[this.list.qid]) {

                this.isSelected = true;
                //获取选中的下标
                // this.answerError = this.selected[this.list.qid];
            } else {
                this.isSelected = false;
            }
        }
    },

    data () {
        return {
            radio: '',
            isSelected: false,
        }
    },
    mounted () {
    },
    methods: {
        /**
         * 选择事件
         */
        handleCheckedQes () {
            // this.list.isChecked = true;
            // if (this.selected[this.list.qid]) {
            //     // this.$message('已经训啊过了');
            //     return false;
            // }
            let obj = {};
            obj[this.list.qid] = this.radio + 1;//+1 从1开始
            this.$emit('changeQes', obj)
        }
    }
}
</script>
<style lang="stylus" scoped>

.el-radio
    display block
    margin-bottom 20px
</style>
<style lang="stylus">
.el-carousel__container
    height 400px
.examRadio
    // background red
    .el-radio
        .el-radio__label
            font-size 16px
            color #4D4D4D
            line-height 28px
            font-weight normal
        .el-radio__inner
            width 28px
            height 28px
            line-height 28px
            border 0 !important
            background-color transparent
            background-size 100% 100% !important
            background-image url('~@/assets/images/circle.png')
            position relative
        .el-radio__inner::after
            width 28px
            height 28px
            font-size 14px
            text-align center
            background none!important
            transform scale(1)
            top 0
            left 0
    .el-radio.A
        .el-radio__inner::after
            content 'A'
    .el-radio.B
        .el-radio__inner::after
            content 'B'
    .el-radio.C
        .el-radio__inner::after
            content 'C'
    .el-radio.D
        .el-radio__inner::after
            content 'D'
    .el-radio.E
        .el-radio__inner::after
            content 'E'
    .el-radio.F
        .el-radio__inner::after
            content 'F'
    .el-radio.G
        .el-radio__inner::after
            content 'G'
    .el-radio.H
        .el-radio__inner::after
            content 'H'
.examRadio.selected
    .el-radio__inner
        // background none
    .ok
        .el-radio__inner
            background-image url('~@/assets/images/ok.png') !important
        .el-radio__inner::after
            content '' !important
    .error
        .el-radio__inner
            background-image url('~@/assets/images/error.png') !important
        .el-radio__inner::after
            content '' !important
</style>


// WEBPACK FOOTER //
// src/components/my/exam/radio.vue